/** Keep child files comfortably below the 50,000-URL sitemap protocol limit. */
export const CALENDAR_SITEMAP_PAGE_SIZE = 10_000;
export const EVENT_SITEMAP_PAGE_SIZE = 10_000;
/**
 * Calendar sitemap children are split by product vertical so Search Console
 * reports indexed rates per vertical instead of mixing them across `_id` slices.
 */
export const SITEMAP_VERTICALS = ["sports", "tv", "movies", "other"];
/** Pre-vertical children (`sitemaps/calendars-1.xml`). Cleanup must still list this. */
export const LEGACY_CALENDAR_SITEMAP_PREFIX = "sitemaps/calendars-";
export function sitemapVerticalObjectPrefix(vertical) {
    return `sitemaps/${vertical}-`;
}
export function calendarSitemapObjectName(vertical, page) {
    return `${sitemapVerticalObjectPrefix(vertical)}${page}.xml`;
}
/** Do not use bare `sitemaps/`; it also matches non-calendar artifacts. */
export const SITEMAP_CALENDAR_CLEANUP_PREFIXES = [
    LEGACY_CALENDAR_SITEMAP_PREFIX,
    ...SITEMAP_VERTICALS.map(sitemapVerticalObjectPrefix),
];
/** Dedicated event pages use their own sitemap children and cleanup scope. */
export const EVENT_SITEMAP_OBJECT_PREFIX = "sitemaps/events-";
export function eventSitemapObjectName(page) {
    return `${EVENT_SITEMAP_OBJECT_PREFIX}${page}.xml`;
}
export const PRODUCT_PAGE_SLUGS = {
    GROUPS: "groups",
    HOW_STANZA_GETS_SCHEDULES: "how-stanza-gets-schedules",
    HOW_CALENDAR_APPS_UPDATE: "how-calendar-apps-update",
    TRANSPARENT_UPDATES: "transparent-updates",
    HOW_SPORTS_FANS_USE_STANZA: "how-sports-fans-use-stanza",
    QUALITY_CALENDARS: "quality-calendars",
    GOOGLE_CONNECT: "google-connect",
    UNLIMITED_CALENDARS: "unlimited-calendars",
    CROSS_DEVICE_SYNC: "cross-device-sync",
    REAL_TIME_UPDATES: "real-time-updates",
    EXCLUSIVE_CALENDARS: "exclusive-calendars",
    FORCE_REFRESH: "force-refresh",
    RECOMMENDATIONS: "recommendations",
    ADD_INDIVIDUAL_EVENTS: "add-individual-events",
    EARLY_ACCESS: "early-access",
    SUGGEST_CALENDARS: "suggest-calendars",
};
//# sourceMappingURL=sitemap.js.map